/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import {
  Help24,
  Checkmark24,
  CheckmarkFilled24,
  CheckmarkOutline24,
  Error24,
  ErrorFilled24,
  ErrorOutline24,
  HelpFilled24,
  Information24,
  InformationFilled24,
  Misuse24,
  MisuseOutline24,
  Undefined24,
  UndefinedFilled24,
  Unknown24,
  UnknownFilled24,
  Warning24,
  WarningAlt24,
  WarningAltFilled24,
  WarningAltInverted24,
  WarningAltInvertedFilled24,
  WarningFilled24,
  WarningSquare24,
  WarningSquareFilled24,
  User24,
  Location24,
  Temperature24,
  Flag24,
  Tag24,
  Alarm24,
  Idea24,
  BatteryFull24,
  BatteryEmpty24,
  FlashFilled24,
  UserFilled24,
  LightFilled24,
  IbmSecurity24,
} from '@carbon/icons-react';
import capitalize from 'lodash/capitalize';

const carbonIcons10 = {
  Checkmark24,
  CheckmarkFilled24,
  CheckmarkOutline24,
  Error24,
  ErrorFilled24,
  ErrorOutline24,
  Help24,
  HelpFilled24,
  Information24,
  InformationFilled24,
  Misuse24,
  MisuseOutline24,
  Undefined24,
  UndefinedFilled24,
  Unknown24,
  UnknownFilled24,
  Warning24,
  WarningAlt24,
  WarningAltFilled24,
  WarningAltInverted24,
  WarningAltInvertedFilled24,
  WarningFilled24,
  WarningSquare24,
  WarningSquareFilled24,
  User24,
  Location24,
  Temperature24,
  Flag24,
  Tag24,
  Alarm24,
  Idea24,
  BatteryFull24,
  BatteryEmpty24,
  FlashFilled24,
  UserFilled24,
  LightFilled24,
  IbmSecurity24,
};

export const getIconKeyByName = name => {
  // some icons changed names
  if (name === 'icon--info--outline') {
    return 'Information24';
  }
  return `${name
    .replace(/icon--/gi, '')
    .replace(/header--/gi, ' ')
    .replace(/--/gi, ' ')
    .replace(/solid/gi, 'filled')
    .split(' ')
    .map(i => capitalize(i))
    .join('')}24`;
};

const getIconFromKey = key => carbonIcons10[key] || carbonIcons10.Help24;
export const getIconByName = name => getIconFromKey(getIconKeyByName(name));

export const bundledIconNames = [
  'caretUp',
  'caretDown',
  'edit',
  'close',
  'checkmark',
  'warning',
  'arrowUp',
  'arrowDown',
  'user',
  'info',
  'help',
];

export const bundledIcons = {
  caretUp: carbonIcons10.CaretUp16,
  caretDown: carbonIcons10.CaretDown16,
  edit: carbonIcons10.Edit16,
  close: carbonIcons10.CloseFilled16,
  checkmark: carbonIcons10.CheckmarkFilled16,
  warning: carbonIcons10.WarningAltFilled16,
  arrowUp: carbonIcons10.ArrowUp16,
  arrowDown: carbonIcons10.ArrowDown16,
  user: carbonIcons10.User16,
  info: carbonIcons10.Information16,
  help: carbonIcons10.Help16,
};
